// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BaseModal[data-v-90c561f0] .el-dialog {
  margin-top: unset !important;
}
.BaseModal[data-v-90c561f0] .el-dialog__header {
  background: #f2f2f2;
  height: 40px;
  padding: 16px 50px 0px 16px;
}
.BaseModal[data-v-90c561f0] .el-dialog__header .header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.BaseModal[data-v-90c561f0] .el-dialog__header .header .left {
  font-weight: 600;
}
.BaseModal[data-v-90c561f0] .el-dialog__body {
  background: #f2f2f2;
  padding: 12px 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/BaseModal/index.vue","webpack://./index.vue"],"names":[],"mappings":"AACA;EAEI,4BAAA;ACDJ;ADDA;EAKI,mBAAA;EACA,YAAA;EACA,2BAAA;ACDJ;ADNA;EAUM,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;ACDN;ADZA;EAgBQ,gBAAA;ACDR;ADfA;EAsBI,mBAAA;EACA,kBAAA;ACJJ","sourcesContent":["\n.BaseModal {\n  ::v-deep .el-dialog {\n    margin-top: unset !important;\n  }\n  ::v-deep .el-dialog__header {\n    background: #f2f2f2;\n    height: 40px;\n    padding: 16px 50px 0px 16px;\n\n    .header {\n      width: 100%;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      .left {\n        font-weight: 600;\n      }\n    }\n  }\n\n  ::v-deep .el-dialog__body {\n    background: #f2f2f2;\n    padding: 12px 16px;\n  }\n}\n",".BaseModal ::v-deep .el-dialog {\n  margin-top: unset !important;\n}\n.BaseModal ::v-deep .el-dialog__header {\n  background: #f2f2f2;\n  height: 40px;\n  padding: 16px 50px 0px 16px;\n}\n.BaseModal ::v-deep .el-dialog__header .header {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.BaseModal ::v-deep .el-dialog__header .header .left {\n  font-weight: 600;\n}\n.BaseModal ::v-deep .el-dialog__body {\n  background: #f2f2f2;\n  padding: 12px 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
